import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Link bileşenini import ediyoruz
import { createClient } from "@supabase/supabase-js";
import { motion } from "framer-motion"; // motion'ı import ediyoruz
import "../../dist.css/NewsListPage.css";

// Supabase bağlantısını oluşturuyoruz
const supabase = createClient(
  "https://qlgwpthiwclfbgzzjmjw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsZ3dwdGhpd2NsZmJnenpqbWp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ2MDUzOTIsImV4cCI6MjA0MDE4MTM5Mn0.N9-IULDnpuUWR_PNXvXyzdTTIMRsxRAxVGrAagaJn4k"
);

const NewsListPage = () => {
  const [newsData, setNewsData] = useState([]); // Haber verilerini tutacak state
  const [loading, setLoading] = useState(true); // Yükleme durumunu tutan state
  const [error, setError] = useState(null); // Hata durumunu tutan state

  useEffect(() => {
    // Veri çekme fonksiyonu
    const fetchNews = async () => {
      setLoading(true); // Veri çekmeye başladık
      const { data, error } = await supabase
        .from("news") // "news" tablosundan veri çekiyoruz
        .select("*"); // Tüm haberleri çekiyoruz

      if (error) {
        console.error("Hata oluştu:", error); // Hata varsa konsola yazdırıyoruz
        setError(error.message); // Hata mesajını state'e kaydediyoruz
        setLoading(false); // Yükleme işlemi tamamlandı
        return;
      }

      if (!data || data.length === 0) {
        setError("Veri bulunamadı."); // Eğer veri yoksa hata mesajı
        setLoading(false); // Yükleme işlemi tamamlandı
        return;
      }

      setNewsData(data); // Veriyi state'e kaydediyoruz
      setLoading(false); // Yükleme tamamlandı
    };

    fetchNews(); // fetchNews fonksiyonunu çağırıyoruz
  }, []); // Component mount olduğunda veri çek

  if (loading) {
    return <div>Yükleniyor...</div>; // Veri yükleniyorsa, "Yükleniyor..." mesajı gösteriyoruz
  }

  if (error) {
    return <div>{error}</div>; // Eğer hata varsa, hata mesajını gösteriyoruz
  }

  if (!newsData || newsData.length === 0) {
    return <div>Haber bulunamadı.</div>; // Eğer veri yoksa, "Haber bulunamadı" mesajı gösteriyoruz
  }

  return (
    <div className="news__list__page">
      <h2 id="news__list__page__title">Haberler</h2>
      {/* Ana konteynerde animasyon */}
      <motion.div
        className="news__list"
        initial="hidden"
        animate="visible"
        variants={{
          hidden: {
            opacity: 0,
            transition: {
              staggerChildren: 0.2, // Kartlar arasındaki gecikmeyi ayarlıyoruz
            },
          },
          visible: {
            opacity: 1,
            transition: {
              staggerChildren: 0.2, // Kartlar arasında 0.2 saniye gecikme
            },
          },
        }}
      >
        {newsData.map((news) => (
          <Link to={`/news/${news.news_id}`} key={news.news_id}>
            {/* Her bir haber kartı için animasyon */}
            <motion.div
              className="news-item"
              variants={{
                hidden: { opacity: 0, y: 30 }, // Kart başlangıçta görünmez ve yukarıda
                visible: { opacity: 1, y: 0 }, // Kart görünür ve normal pozisyona gelir
              }}
              transition={{ duration: 0.5 }} // Animasyon süresi
            >
              <h2>{news.news_title}</h2>
              <div className="news-summary">
                <img
                  src={news.news_img}
                  alt={news.news_title}
                  className="news-image"
                />
                <p
                  dangerouslySetInnerHTML={{
                    __html: news.news_content.slice(0, 150) + "...", // HTML içeriği ekliyoruz
                  }}
                />
              </div>
            </motion.div>
          </Link>
        ))}
      </motion.div>
    </div>
  );
};

export default NewsListPage;
